import { api } from '../api/client.js';

export function renderAuthView(root: HTMLElement): void {
  root.innerHTML = `
    <main class="auth">
      <div class="auth__brand">
        <div class="auth__logo" aria-hidden="true">🌳</div>
        <h1 class="auth__title">memori</h1>
        <p class="auth__tagline">思考が消える前に</p>
      </div>
      <button class="auth__google" type="button" id="google-signin">
        <span class="auth__google-icon" aria-hidden="true">G</span>
        <span>Google でログイン</span>
      </button>
      <p class="auth__note">ベータ招待制です</p>
      <p class="auth__message" id="auth-message" aria-live="polite"></p>
    </main>
  `;

  const button = root.querySelector<HTMLButtonElement>('#google-signin')!;
  const message = root.querySelector<HTMLParagraphElement>('#auth-message')!;

  button.addEventListener('click', async () => {
    button.disabled = true;
    message.textContent = 'Google にリダイレクトしています…';
    try {
      const callbackURL = `${location.origin}/auth/callback`;
      const { url } = await api.signInGoogle(callbackURL);
      window.location.href = url;
    } catch (err) {
      console.error(err);
      message.textContent = 'ログインに失敗しました 🔄 もう一度';
      button.disabled = false;
    }
  });
}
